<template>
    <b-container fluid>
        <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('ds_institute_management.library_book_distribution') }} {{ $t('globalTrans.search') }}</h4>
            </template>
            <b-col>
                <b-row>
                    <b-col lg="6" md="6" sm="12" xs="12" class="mt-3">
                        <ValidationProvider name="Organization" vid="organization" rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="organization"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('ds_institute_management.organization_name')}}
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.org_id"
                                    id="organization"
                                    :options="orgList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :disabled="$store.state.Auth.authUser.role_id === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6" md="6" sm="12" xs="12" class="mt-3">
                        <ValidationProvider name="Institute Type" vid="institute_type" rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="institute_type"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('ds_institute_management.institute_type')}}
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.office_type_id"
                                    id="institute_type"
                                    :options="officeTypeList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6" md="6" sm="12" xs="12" class="">
                        <ValidationProvider name="Institute Name" vid="institute_name" rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="institute_name"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('ds_institute_management.institute_name')}}
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.office_id"
                                    id="institute_name"
                                    :options="officeList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :disabled="$store.state.Auth.authUser.is_org_admin === 1 ? false : true" :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6" md="6" sm="12" xs="12" class="">
                        <ValidationProvider name="Class" vid="class_id" rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="class_id"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('ds_institute_management.class')}}
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.class_id"
                                    id="class_id"
                                    :options="classList"
                                    @change="getStudentData(search.class_id)"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6" md="6" sm="12" xs="12" class="">
                        <b-spinner v-if="studentSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                        <ValidationProvider name="Student ID" vid="student_id" rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="student_id"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{$t('ds_institute_management.student_id')}}
                                </template>
                                <b-form-select
                                    plain
                                    v-model="search.student_id"
                                    id="student_id"
                                    :options="applicantlist"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                </b-form-select>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6" sm="12">
                        <ValidationProvider name="Start Date" vid='start_date' rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="start_date"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{ $t('ds_institute_management.start_date')}}
                                </template>
                                <flat-pickr class="form-control"
                                            v-model="search.start_date"
                                            id="start_date"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                >
                                </flat-pickr>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="6" sm="12">
                        <ValidationProvider name="End Date" vid='end_date' rules="">
                            <b-form-group
                                class="row"
                                label-cols-sm="4"
                                label-for="end_date"
                                slot-scope="{ valid, errors }"
                            >
                                <template v-slot:label>
                                    {{ $t('ds_institute_management.end_date')}}
                                </template>
                                <flat-pickr class="form-control"
                                            v-model="search.end_date"
                                            id="end_date"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                >
                                </flat-pickr>
                                <div class="invalid-feedback">
                                    {{ errors[0] }}
                                </div>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col lg="12" md="6" sm="12">
                        <b-button type="button" style="margin-bottom:15px" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </iq-card>
        <b-row>
            <b-col md="12">
                <iq-card>
                    <template v-slot:headerTitle>
                        <h4 class="card-title">{{ $t('ds_institute_management.library_book_distributions') + ' ' + $t('globalTrans.list')}}</h4>
                    </template>
                    <template v-slot:headerAction>
                        <b-button variant="primary" v-b-modal.modal-4 @click="resetId">
                            {{  $t('globalTrans.add_new') }}
                        </b-button>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loadingState">
                            <b-row>
                                <b-col md="12" class="table-responsive">
                                    <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                                        <template v-slot:cell(index)="data">
                                            {{ $n(data.index + pagination.slOffset) }}
                                        </template>
                                        <template v-slot:cell(distribution_date)="data">
                                            {{ data.item.distribution_date | dateFormat }}
                                        </template>
                                        <template v-slot:cell(status)="data">
                                            <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                                            <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                                        </template>
                                        <template v-slot:cell(action)="data">
                                            <b-button class="mr-1" title="View Details" v-b-modal.modal-detail variant=" iq-bg-success mr-1" size="sm" @click="edit(data.item)"><i class="ri-eye-line m-0 "></i></b-button>
                                            <b-button v-b-modal.modal-4 variant=" iq-bg-success mr-1 mb-1" size="sm" title="Edit" @click="edit(data.item)"><i class="ri-ball-pen-fill m-0"></i></b-button>
                                        </template>
                                    </b-table>
                                    <b-pagination
                                        v-model="pagination.currentPage"
                                        :per-page="pagination.perPage"
                                        :total-rows="pagination.totalRows"
                                        @input="searchData"
                                    />
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
        <b-modal id="modal-4" size="lg" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <p>
                <FormV :id="editItemId" :key="editItemId" :item="item"/>
            </p>
        </b-modal>
        <b-modal id="modal-detail" size="lg" :title="$t('globalTrans.details')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <p>
                <FormK :id="editItemId" :key="editItemId" :booklist="booklistTwo" :item="item"/>
            </p>
        </b-modal>
    </b-container>
</template>
<script>
import FormV from './Form'
import FormK from './Detail'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import {
    LibraryBookDistributionListApi,
    LibraryBookDistributionStudentListApi,
    LibraryBookDistributionToggleStatusApi
} from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
    mixins: [ModalBaseMasterList],
    components: {
        FormV, FormK
    },
    data () {
        return {
          studentSpinLoader: false,
          ItemShow: false,
          editItemId: 0,
          applicantlist: [],
          officeTypeList: [],
          officeList: [],
          booklist: [],
          booklistTwo: [],
          item: [],
            search: {
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                class_id: '',
                student_id: '',
                start_date: '',
                end_date: ''
            }
        }
    },
    created () {
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
      this.loadData()
    },
    computed: {
        orgList: function () {
            const obj = this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
            return obj.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        classList: function () {
            return this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        formTitle () {
            return (this.editItemId === 0) ? this.$t('ds_institute_management.distribution_for') + ' ' + this.$t('globalTrans.entry') : this.$t('ds_institute_management.distribution_for') + ' ' + this.$t('globalTrans.modify')
        },
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('ds_institute_management.organization_name'), class: 'text-left' },
                { label: this.$t('ds_institute_management.institute_type'), class: 'text-left' },
                { label: this.$t('ds_institute_management.institute_name'), class: 'text-left' },
                { label: this.$t('ds_institute_management.class'), class: 'text-left' },
                { label: this.$t('ds_institute_management.distribution_date'), class: 'text-left' },
                { label: this.$t('awareness_config.status'), class: 'text-left' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]
            let keys = []
            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'index' },
                    { key: 'org_name_bn' },
                    { key: 'office_type_bn' },
                    { key: 'office_name_bn' },
                    { key: 'class_name_bn' },
                    { key: 'distribution_date' },
                    { key: 'status' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'index' },
                    { key: 'org_name' },
                    { key: 'office_type' },
                    { key: 'office_name' },
                    { key: 'class_name' },
                    { key: 'distribution_date' },
                    { key: 'status' },
                    { key: 'action' }
                ]
            }
            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
      }
    },
    watch: {
        'search.org_id': function (newVal) {
            this.getOfficeTypeList()
        },
        'search.office_type_id': function (newVal) {
            this.getOfficeList()
        },
        '$i18n.locale': function (newVal) {
            this.getOfficeTypeList()
            this.getOfficeList()
        }
    },
    methods: {
        edit (item) {
            this.editItemId = item.id
            this.item = item
        },
        remove (item) {
            this.changeStatus(disabilitySchoolServiceBaseUrl, LibraryBookDistributionToggleStatusApi, item)
        },
        async getStudentData (classId) {
            this.studentSpinLoader = true
            let result = null
            result = await RestApi.postData(disabilitySchoolServiceBaseUrl, LibraryBookDistributionStudentListApi, { office_id: this.search.office_id, class_id: classId })
            if (result.success) {
                this.studentSpinLoader = false
                this.applicantlist = result.data
                this.applicantlist.map(element => {
                    element.value = element.id
                    element.text = this.$i18n.locale === 'en' ? element.name_en + ' (' + element.student_id + ')' : element.name_bn + ' (' + this.$n(element.student_id, { useGrouping: false }) + ')'
                })
            } else {
            }
        },
        getOfficeTypeList () {
            if (this.search.org_id) {
                this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id)
            }
        },
        getOfficeList () {
            if (this.search.office_type_id) {
                this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id)
            }
        },
        searchData () {
          this.loadData()
        },
        loadData () {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
          RestApi.getData(disabilitySchoolServiceBaseUrl, LibraryBookDistributionListApi, params).then(response => {
              if (response.success) {
                  this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                  this.paginationData(response.data)
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
          })
      },
      getRelationalData (data) {
        let orgList = {}
        let officeTypeList = {}
        let officeList = {}
          const listData = data.map(item => {
                orgList = this.$store.state.orgList.find(org => org.value === item.org_id)
                officeTypeList = this.$store.state.commonObj.officeTypeList.find(officeType => officeType.value === item.office_type_id)
                officeList = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id)
                const tmpClass = this.$store.state.DisabilitySchoolService.commonObj.classList.find(el => el.value === parseInt(item.class_id))
                const data = {
                    org_name: orgList !== undefined ? orgList.text_en : '',
                    org_name_bn: orgList !== undefined ? orgList.text_bn : '',
                    office_type: officeTypeList !== undefined ? officeTypeList.text_en : '',
                    office_type_bn: officeTypeList !== undefined ? officeTypeList.text_bn : '',
                    office_name: officeList !== undefined ? officeList.text_en : '',
                    office_name_bn: officeList !== undefined ? officeList.text_bn : '',
                    class_name: tmpClass !== undefined ? tmpClass.text_en : '',
                    class_name_bn: tmpClass !== undefined ? tmpClass.text_bn : ''
                }
                return Object.assign({}, item, data)
          })
          return listData
      }
    }
  }
</script>

<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
.width-fixed {
    width: 25%
}
</style>
